module.exports = __webpack_public_path__ + "img/VIRTUAL_ACCOUNT_BANK_BSS.97367dfd.png";